module.exports = __webpack_public_path__ + "pc/img/body_basic 14.d9d8197e.jpg";